import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LocalStorageService } from './local-storage.service';
import { DataService } from './data.service';
import { BodyClassService } from './body-class.service';
import { InfiniteScrollComponent } from './infinite-scroll/infinite-scroll.component';
import { VQFormsModule } from '../vqforms/vqforms.module';
import { VQModalComponent, ModalService } from './vq-modal/vq-modal.component';
import { VQModalUploadComponent, ModalUploadService } from './vq-modal/vq-modal-upload.component';
import { VQAlertComponent, AlertService } from './vq-alert/vq-alert.component';
import { AuthGuard } from './auth.guard';
import { RedirectGuard } from './redirect.guard';
import { RouterModule } from '@angular/router';
// import { VqModalInjectComponent, ModalInjectService } from './vq-modal-inject/vq-modal-inject.component';
// import { EquipmentsModule } from '../equipments/equipments.module';
import { FileUploadModule } from "ng2-file-upload";
import { FilterPipe } from './filter.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    FileUploadModule,
    VQFormsModule,
    // EquipmentsModule
  ],
  exports: [
    InfiniteScrollComponent,
    VQModalComponent,
    VQModalUploadComponent,
    VQAlertComponent,
    FilterPipe,
    // TabsHearderService
  	// LocalStorageService,
  ],
  declarations: [
    InfiniteScrollComponent,
    VQModalComponent,
    VQModalUploadComponent,
    VQAlertComponent,
    FilterPipe,
    // VqModalInjectComponent,
  	// LocalStorageService,

  ],
  providers: [
    AuthGuard,
    RedirectGuard,
  	LocalStorageService,
    DataService,
    AlertService,
    ModalService,
    ModalUploadService,
    BodyClassService,
  ]
})
export class VQUtilsModule { }



// WEBPACK FOOTER //
// ./src/app/vqutils/vqutils.module.ts